import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiPost } from "@/shared/api";

/**
 * Отметить все события прочитанными.
 *
 * Инвалидируется префикс `["activity"]`, а не конкретный фильтр: флаг
 * `is_read` меняется во всех четырёх лентах сразу, и обновить только текущую
 * значило бы оставить остальные с непрочитанными записями.
 */
export function useReadAll() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: () => apiPost("/api/v1/activity/read-all", {}),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ["activity"] });
    },
  });
}
